import type { ReactNode } from 'react';
import type { IsoDateTime } from '@/domain/types';
import { formatDateTime } from '../format';
import './Timeline.css';

export interface TimelineItem {
  id: string;
  at: IsoDateTime;
  title: ReactNode;
  detail?: ReactNode;
  tone?: 'neutral' | 'ok' | 'gold' | 'danger' | undefined;
}

/** Vertical event list (backup history, händelselogg, account history). */
export function Timeline({ items, emptyText = 'Inget ännu.', className }: { items: readonly TimelineItem[]; emptyText?: string | undefined; className?: string | undefined }) {
  if (!items.length) return <p className="text-small text-2">{emptyText}</p>;
  return (
    <ol className={['timeline', className ?? ''].filter(Boolean).join(' ')}>
      {items.map((it) => (
        <li key={it.id} className={`timeline-item timeline-${it.tone ?? 'neutral'}`}>
          <span className="timeline-dot" aria-hidden="true" />
          <div className="timeline-body">
            <time className="timeline-time" dateTime={it.at}>
              {formatDateTime(it.at)}
            </time>
            <div className="timeline-title">{it.title}</div>
            {it.detail ? <div className="timeline-detail">{it.detail}</div> : null}
          </div>
        </li>
      ))}
    </ol>
  );
}
